//import Libraries
import React, {Component} from 'react';
import {connect} from 'react-redux';

//import Components
import { Table } from 'reactstrap';
import Account from './Account';
import * as accountActions from './actions/accountActions';

//import Styles
import './Account.css';

class AccountTable extends Component {

    constructor(props) {
        super(props);

        const {accounts} = props;

        this.state = {
            allChecked : false,
            checked : new Array(accounts.length).fill(false)
        }
    }

    compareCheckedArray = (arr1, arr2) => {
        if(arr1.length !== arr2.length) {
            return false;
        }

        for(let i = 0; i < arr1.length; ++i) {
            if(arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.accounts.length != this.props.accounts.length) {
            this.setState({
                checked : new Array(this.props.accounts.length).fill(false)
            })
            return;
        }

        if(!this.compareCheckedArray(prevState.checked, this.state.checked) ) {
            let ids = [];
            this.state.checked.map((check, index) => {
                if(check) {
                    ids.push(this.props.accounts[index].id);
                }
            })    
            this.props.onUpdateCheckedAccounts(ids);
        }
    }

    handleOnCheckboxChange = (e) => {
        const checked = e.target.checked;
        let checkedState = [...this.state.checked];
        let allChecked = true;
        if(e.target.name.includes('parent')) {
            checkedState.fill(checked);
            allChecked = checked;
        } else {
            const index = parseInt(e.target.name);
            checkedState[index] = checked;
            checkedState.forEach(element => {
                if (element === false) {
                    allChecked = false;
                }
            })
        }
        this.setState({
            checked: checkedState,
            allChecked
        })
    }

    render() {
        const {accounts} = this.props;

        return (
            <Table responsive>
                <thead>
                    <tr>
                        <th>이름</th>
                        <th>소속</th>
                        <th>전화번호</th>
                        <th>주문횟수</th>
                        <th>주소</th>
                        <th>온실형태</th>
                        <th>재배작물</th>
                        <th>재배면적</th>
                        <th>회원승인</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        accounts.map((account, index) => {
                            return (
                                <Account
                                    account={account}
                                    key={index} />
                            );
                        })
                    }
                </tbody>
            </Table>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onDeleteAccount : (id) => {
            dispatch(accountActions.deleteAccount(id));
        },
        onUpdateCheckedAccounts : (ids) => {
            dispatch(accountActions.updateCheckedAccounts(ids));
        }
    }
}

export default connect(null, mapDispatchToProps)(AccountTable);


// WEBPACK FOOTER //
// ./src/pages/Admin/AccountManager/AccountTable.js